// https://github.com/cferdinandi/gumshoe

gumshoe.init({

	activeClass: 'is-active', // Class to apply to active navigation link and its parent list item

});